// Mirrors the core's Hermes.Pools.Pool.joinable?/1 (open/calling/paused). One copy for
// the whole SPA: the cockpit's picker and the console's board answer the same question,
// and two lists drifting apart would have them disagree about the same pool.
export const JOINABLE_POOL_STATES = ['open', 'calling', 'paused'] as const;
